import { isValidDataKey } from '@utils/sagaResponseValidator';
export const isPayTransactionStatus = (data) => isValidDataKey(data, 'pay_transaction', true);
